import {device, useStorage} from '#/storage'

export function useExternalEntryPromptShown() {
  const [shown = false, setShown] = useStorage(device, [
    'externalEntryPromptShown',
  ])
  return [shown, setShown] as const
}
